<router-outlet />

<ng-template #errorTemplate>
  <error-modal />
</ng-template>

<ng-template #signInTemplate>
  <sign-in-modal
    [currentUrl]="this.signInModalService.currentUrl"
    (hideModal)="hideSignInModal()"
    (continueWithGoogle)="continueWith(cognitoHostedUIIdentityProvider.Google)"
    (continueWithFacebook)="continueWith(cognitoHostedUIIdentityProvider.Facebook)"
    (continueWithEmail)="continueWithEmail()"
  />
</ng-template>

<ng-template #continueWithEmailTemplate>
  <continue-with-email-modal
    (hideModal)="hideModal()"
    (sendEmail)="sendEmail($event)"
    [activationError]="activationError"
  />
</ng-template>

<ng-template #activationCodeTemplate>
  <activation-code-modal
    (validateCode)="validateNewEmailCode($event)"
    (sendActivationEmail)="sendEmail(email)"
    (hideModal)="hideModal()"
    [activation]="activation"
    [activationPassed]="activationPassed"
    [activationError]="activationError"
  />
</ng-template>

<ng-template #verificationTemplate>
  @let verification = verificationModalService.verificationData;
  @if (verification) {
    <verification-modal
      (validateCode)="validateCode($event)"
      (portalSendVerificationEmail)="portalSendVerificationEmail()"
      (hideModal)="hideModal()"
      [verification]="verification"
      [verificationPassed]="verificationModalService.verificationPassed"
      [verificationError]="verificationModalService.verificationError"
    />
  }
</ng-template>

<ng-template #passcodeTemplate>
  <passcode-modal
    (validatePasscode)="validatePasscode($event)"
    (hideModal)="hideModal()"
    [passcodePassed]="passcodeModalService.passcodePassed"
    [passcodeError]="passcodeModalService.passcodeError"
  />
</ng-template>
